import React from "react";
import classNames from "classnames";
import {
  CheckCircle as IconoirCheckCircle,
  Info as IconoirInfoCircle,
  ErrorOutline as IconoirWarningCircle,
  Warning as IconoirWarningTriangle,
  Close
} from "@mui/icons-material";

import Icon from "../../icon";

import "./toast.scss";

type ToastProps = {
  actions?: any[];
  children?: React.ReactNode;
  supportingText?: string;
  className?: string;
  variant: any;
  position: "" | "top" | "bottom";
  onClose?: any;
  actionButtonProps?: Record<string, Record<string, boolean>>;
  closeButtonProps?: Record<string, Record<string, boolean>>;
  icons?: any;
  other?: Record<string, any>;
};

export const Toast = ({
  actions,
  children,
  supportingText,
  className,
  variant,
  position,
  onClose,
  closeButtonProps,
  icons: userIcons,
  ...other
}: ToastProps) => {
  const classes = classNames({
    "motif-toast": true,
    "motif-toast-success": variant === "success",
    "motif-toast-error": variant === "error",
    "motif-toast-warning": variant === "warning",
    "motif-toast-info": variant === "info",
    "motif-toast-fixed-top": position === "top",
    "motif-toast-fixed-bottom": position === "bottom",
    [className!]: true
  });

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      className={classes}
      {...other}
      data-motif-toast
    >
      <div className="motif-toast-content">
        <div className="motif-toast-icon-container">
          <>
            {variant === "error" && <IconoirWarningCircle />}
            {variant === "success" && <IconoirCheckCircle />}
            {variant === "warning" && <IconoirWarningTriangle />}
            {variant === "info" && <IconoirInfoCircle />}
          </>
        </div>
        <div className="motif-toast-text-container">
          <div className="motif-body2-default-regular">
            {children}
            <div className="motif-body2-default-light">{supportingText}</div>
          </div>
        </div>
        <Icon
          data-testid="toast-close"
          aria-label="Click here to remove toast"
          className="motif-toast-close-button"
          onClick={onClose}
          {...closeButtonProps}
          src={<Close />}
        />
      </div>
    </div>
  );
};
